import { render, staticRenderFns } from "./OffersCardItems.vue?vue&type=template&id=73a46ba0&scoped=true&lang=pug&"
import script from "./OffersCardItems.vue?vue&type=script&lang=js&"
export * from "./OffersCardItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a46ba0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
